import { FormChoice } from '../../components/form/form-choices.js';
class ContactMap {
    constructor (element) {
        // Elements
        this.$contactModule = element;
        this.$mapWrapper = this.$contactModule.querySelector('[data-contact="map"]');
        this.$infoBox = this.$contactModule.querySelector('[data-contact="info-box"]');
        this.$infoBoxClose = this.$contactModule.querySelector('[data-contact-close]');
        this.$infoBoxCompany = this.$contactModule.querySelector('[data-contact="company"]');
        this.$infoBoxContact = this.$contactModule.querySelector('[data-contact="contact"]');
        this.$infoBoxAddress = this.$contactModule.querySelector('[data-contact="address"]');
        this.$choices = this.$contactModule.querySelector('[data-contact="choices"]');
        this.$$filter = this.$contactModule.querySelectorAll('[data-contact="filter"] input');

        // Settings
        this.locations = window.contactLocations;
        this.markers = [];
        this.map = null;
        this.ym = null;
        this.infoBoxIsOpen = false;
        this.infoBoxType = null;
        this.infoBoxWidth = this.$infoBox?.clientWidth;

        if (window.innerWidth >= 1024) {
            this.zoom = 3;
        } else {
            this.zoom = 1;
        }
    }

    initialize () {
        if (this.$mapWrapper) {
            window.ym.ready((modules) => {
                this.ym = window.ym;
                this.initMap();
                this.initCluster();
                this.initMarkers();
                this.initChoices();
                this.setEvents();
            });
        }
    }

    initChoices () {
        this.choices = new FormChoice(this.$choices);
        this.choices.initialize();
    }

    initMap () {
        const map = this.ym.map(this.$mapWrapper, {
            center: this.ym.latLng(0, 0),
            zoom: this.zoom,
            minZoom: 1,
            maxZoom: 24,
            brandControl: false
        });

        this.map = map;
    }

    initCluster () {
        this.cluster = this.ym.markerClusterGroup({
            spiderfyOnMaxZoom: false,
            showCoverageOnHover: false,
            zoomToBoundsOnClick: true,
            iconCreateFunction: (cluster) => {
                const markers = cluster.getAllChildMarkers();
                const output =
                        '<b>' +
                        Intl.NumberFormat('de-DE', {
                            maximumSignificantDigits: 3
                        }).format(markers.length) +
                        '</b>';
                return this.ym.divIcon({
                    html: output,
                    className: 'contact__map-cluster',
                    iconSize: this.ym.point(28, 28)
                });
            }
        });

        this.map.addLayer(this.cluster);
    }

    initMarkers () {
        this.locations.forEach(location => {
            const marker = this.ym.marker([location.lat, location.lng]);

            const defaultIcon = this.ym.divIcon({
                className: `contact__map-marker contact__map-marker--${location.type}`,
                iconSize: [35, 35]
            });

            marker.setIcon(defaultIcon);

            marker.addTo(this.cluster).setIcon(defaultIcon);
            this.markers.push(marker);
        });
    }

    toggleMarker (group, enable) {
        this.locations.forEach((marker, index) => {
            if (marker.type === group) {
                if (enable) {
                    this.cluster.addLayer(this.markers[index]);
                } else {
                    this.cluster.removeLayer(this.markers[index]);
                }
            }
        });
    }

    generateInfoBox (index, callback) {
        const data = {
            company: this.locations[index].company,
            name: this.locations[index].name,
            address: this.locations[index].address,
            zipcode: this.locations[index].zipcode,
            city: this.locations[index].city,
            country: this.locations[index].country,
            country_code: this.locations[index].country_code ? this.locations[index].country_code : null,
            phone: this.locations[index].phone,
            email: this.locations[index].email,
            website_link: this.locations[index].website_link,
            website_label: this.locations[index].website_label,
            website_target: this.locations[index].website_target,
            id: this.locations[index].id,
            type: this.locations[index].type
        };

        this.infoBoxType = this.locations[index].type;

        // create and insert company name
        let template = '';

        if (data.company !== null) {
            template += '<p>' + data.company + '</p>';
        }

        const company = document.createElement('div');
        company.innerHTML = template;
        this.$infoBoxCompany.innerHTML = company.innerHTML;

        // create and insert contact information
        template = '';

        if (!data.name && !data.phone && !data.email && !data.website_label) {
            template += '<p>' + this.$infoBox.getAttribute('data-no-information') + '</p>';
        } else {
            if (data.name) { template += '<p class="contact__sidebar__name">' + data.name + '</p>'; }
            if (data.phone) { template += '<a href="tel:' + data.phone + '">' + data.phone + '</a>'; }
            if (data.email) { template += '<a href="mailto:' + data.email + '">' + data.email + '</a>'; }
            if (data.website_link && data.website_label && data.website_target) { template += '<a href="' + data.website_link + '" target="' + data.website_target + '" rel="nofollow">' + data.website_label + '</a>'; }
        }

        const contact = document.createElement('div');
        contact.innerHTML = template;
        this.$infoBoxContact.innerHTML = contact.innerHTML;

        // create and insert address information
        template = '';
        template += '<p>' + data.address + '</p>';
        template += '<p>' + data.zipcode + ' ' + data.city + '</p>';

        if (data.country !== '') {
            template += '<p>' + data.country + '</p>';
        }

        const address = document.createElement('div');
        address.innerHTML = template;
        this.$infoBoxAddress.innerHTML = address.innerHTML;

        if (typeof callback === 'function') {
            callback();
        }
    }

    toogleInfoBox (shouldOpen) {
        if (shouldOpen) {
            this.$infoBox.classList.add('is--visible');
            this.infoBoxIsOpen = true;
        } else {
            this.$infoBox.classList.remove('is--visible');
            this.map.panBy([this.infoBoxWidth * -0.5, 0]);
            this.infoBoxIsOpen = false;
        }
    }

    moveMapToCountry (countryCode) {
        let zoomIndex = 6;
        const filteredLocations = {};
        const bigCountries = ['AU', 'CN', 'RU', 'US', 'CA', 'BR'];

        if (countryCode === 'all' || countryCode === '') {
            this.map.setView([0, 0], this.zoom);

            return false;
        }

        if (bigCountries.includes(countryCode)) {
            zoomIndex = 4;
        }

        const calculateAverageValue = (object) => {
            if (Object.keys(object).length === 0) {
                return null;
            }

            let sumLat = 0;
            let sumLng = 0;

            for (const entry in object) {
                if (Array.isArray(object[entry]) && object[entry].length === 2) {
                    sumLat += object[entry][0];
                    sumLng += object[entry][1];
                }
            }

            const averageLat = sumLat / Object.keys(object).length;
            const averageLng = sumLng / Object.keys(object).length;

            return [averageLat, averageLng];
        };

        for (const location in this.locations) {
            if (this.locations[location].country_code === countryCode) {
                filteredLocations[Object.keys(filteredLocations).length] = [this.locations[location].lat, this.locations[location].lng];
            }
        }

        this.map.setView(calculateAverageValue(filteredLocations), zoomIndex);
    }

    setEvents () {
        // Generate and open info box if marker is clicked
        this.markers.forEach((marker, index) => {
            marker.on('click', () => {
                this.generateInfoBox(index);
                const markerLatLng = marker.getLatLng();
                const horizontalOffset = this.infoBoxWidth * 0.5;
                const newCenter = [markerLatLng.lat, markerLatLng.lng + (horizontalOffset / (2 ** 12))];
                this.map.setView(newCenter, 12);

                if (!this.infoBoxIsOpen) {
                    this.toogleInfoBox(true);
                }
            });
        });

        // Close info box if map is clicked
        this.map.on('click', () => {
            if (this.infoBoxIsOpen) {
                this.toogleInfoBox(false);
            }
        });

        // Close info box if close icon is clicked
        if (this.$infoBoxClose) {
            this.$infoBoxClose.addEventListener('click', () => {
                if (this.infoBoxIsOpen) {
                    this.toogleInfoBox(false);
                }
            });
        }

        // Handle region change
        this.$choices.addEventListener('change', () => {
            if (this.infoBoxIsOpen) {
                this.toogleInfoBox(false);
            }

            this.moveMapToCountry(this.$choices.value);
        });

        // Enabled/disable marker if filter has changed
        if (this.$$filter.length > 0) {
            this.$$filter.forEach(filter => {
                filter.addEventListener('change', () => {
                    const group = filter.id;

                    // Close info box if currently opened content is from that category that should be hidden
                    if (this.infoBoxIsOpen && group === this.infoBoxType && !filter.checked) {
                        this.toogleInfoBox(false);
                    }

                    this.toggleMarker(group, filter.checked);
                });
            });
        }

        let resizeTimeout;

        window.addEventListener('resize', () => {
            clearTimeout(resizeTimeout);

            resizeTimeout = setTimeout(() => {
                if (this.infoBoxIsOpen) {
                    this.toogleInfoBox(false);
                }

                this.infoBoxWidth = this.$infoBox?.clientWidth;
            }, 200);
        });
    }
}

export { ContactMap };
